'use client';
import { VStack } from '@chakra-ui/react';
import { memo, useCallback, useMemo, useState } from 'react';

import BlockHeader from 'shared/BlockHeader';
import ButtonGoTo from 'shared/ButtonGoTo';
import DomainFilter from './DomainFilter';
import CasesList from './CasesList';
import { goTo } from 'shared/lib';

import { projectsPageBlockCasesData } from 'constants/ProjectCases/casesDatas/projectsPageCasesData';

const sectionId = 'allProjectCases';
const initialCardsCount = 7;

const AllProjectCasesComponent = () => {
  const [selectedDomains, setSelectedDomains] = useState([]);
  const [cardsCount, setCardsCount] = useState(initialCardsCount);

  const filteredCardsData = useMemo(
    () =>
      selectedDomains.length > 0
        ? projectsPageBlockCasesData.filter(({ domain }) => selectedDomains.includes(domain))
        : projectsPageBlockCasesData,
    [selectedDomains],
  );

  const visibleCardsData = useMemo(
    () => filteredCardsData.slice(0, cardsCount),
    [cardsCount, filteredCardsData],
  );

  const onButtonClick = useCallback(() => {
    if (cardsCount < filteredCardsData.length) {
      setCardsCount(prev => prev + 5);
    } else {
      goTo(sectionId);
      setTimeout(() => {
        setCardsCount(initialCardsCount);
      }, 600);
    }
  }, [cardsCount]);

  return (
    <VStack
      as="section"
      id={sectionId}
      w="full"
      align="start"
      gap={{ mobile: '24px', tablet: '32px', laptop: '40px' }}
    >
      <BlockHeader>Примеры работ</BlockHeader>

      <VStack w="full" align="start" gap={{ mobile: '24px', tablet: '32px', laptop: '48px' }}>
        <DomainFilter selectedDomains={selectedDomains} setSelectedDomains={setSelectedDomains} />

        <VStack w="full" align="start" gap={{ mobile: '24px', laptop: '40px' }}>
          <CasesList cardsData={visibleCardsData} />

          {filteredCardsData.length > initialCardsCount && (
            <ButtonGoTo
              size="secondary"
              w="full"
              btnText={cardsCount < filteredCardsData.length ? 'Показать ещё' : 'Свернуть кейсы'}
              enableGoTo={false}
              onBtnClick={onButtonClick}
            />
          )}
        </VStack>
      </VStack>
    </VStack>
  );
};

export const AllProjectCases = memo(AllProjectCasesComponent);
